import { render, staticRenderFns } from "./PurchaseLedger.vue?vue&type=template&id=23db837a"
import script from "./PurchaseLedger.vue?vue&type=script&lang=js"
export * from "./PurchaseLedger.vue?vue&type=script&lang=js"
import style0 from "./PurchaseLedger.vue?vue&type=style&index=0&id=23db837a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports